// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.results-page-wrap {
    min-height: 100vh;
    font-family: "Inter", sans-serif;
}

.results-page-wrap .results-content-wrap {
    padding: 20px 50px;
    background: #150924;
    min-height: calc(100vh - 83px);
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
}

.results-page-wrap .result-mobile-header {
    display: none;
}

.results-page-wrap .results-content-header {
    display: flex;
    justify-content: space-between;
}

.results-page-wrap .back {
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.02em;
    text-align: left;
    color: #ffffff;
    display: flex;
    gap: 12px;
}

.results-page-wrap .improvment-title {
    font-family: "Inter", sans-serif;
    font-size: 24px;
    font-weight: 600;
    letter-spacing: -0.02em;
    text-align: left;
    color: #ffb800;
    display: flex;
    gap: 16px;
    margin-top: 20px;
    margin-bottom: 20px;
}

.results-page-wrap .greenColor {
    color: #06efc5;
}

.results-page-wrap .based-on-title {
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: -0.02em;
    text-align: left;
    color: #ffffff;
}

.results-page-wrap .buttons-wrap {
    display: flex;
    margin: 30px 0px;
    gap: 30px;
}

.results-page-wrap .video-container {
    position: relative;
    width: 43%;
    max-width: 480px;
    /* height: auto; */
    cursor: pointer;
    height: 450px;
}

.results-page-wrap video {
    width: 100%;
    height: 100%;
}

.play-button-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 48px;
    color: white;
    text-shadow: 0px 0px 5px black;
    pointer-events: none;
}

.results-page-wrap .primaryButton {
    background: #06efc5;
    font-size: 18px;
    font-weight: 800;
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    text-wrap: nowrap;
    line-height: normal;
    padding: 13px 17px;
    min-width: 357px;
    height: fit-content;
    -webkit-text-fill-color: #242424;
}

.results-page-wrap .secondaryButton {
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    background: #ffffff1a;
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    font-family: "Inter", sans-serif;
    text-wrap: nowrap;
    height: fit-content;
    padding: 13px 25px;
    line-height: normal;
    -webkit-text-fill-color: #ffffff;
}

.results-page-wrap .downloadButton {
    font-size: 16px;
    padding: 15px 16px;
}

.results-page-wrap .feedbacks-content-wrap {
    background: #291e36;
    color: white;
    padding: 20px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    width: 68vw;
}

.results-page-wrap .feedbacks-content-wrap .feedback-heading {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: -0.02em;
    text-align: left;
    margin-bottom: 20px;
}

.results-page-wrap .feedbacks-content-wrap .feedback-content-wrap {
    max-height: 44vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 30px;
    padding-right: 20px;
}

.results-page-wrap .feedbacks-content-wrap .feedback-card-wrap {
    display: flex;
    gap: 16px;
}

.results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ques-title {
    font-size: 16px;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.02em;
    text-align: left;
}

.results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ques-desc {
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.02em;
    text-align: left;
}

.results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-title {
    font-size: 16px;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.02em;
    text-align: left;
    margin-bottom: 12px;
}

.results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-desc {
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.02em;
    text-align: left;
}

.results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-wrap {
    margin-top: 20px;
    padding-left: 10px;
}

.results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ques-wrap {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-height: 42px;
    justify-content: center;
}

.results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-desc p:nth-of-type(1) {
    margin-bottom: 8px;
}

.results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-desc .lineheightPara {
    line-height: 32px;
    margin-bottom: 0;
}

.results-page-wrap .feedback-footer-wrap {
    display: flex;
    gap: 23px;
    justify-content: space-between;
}

.results-page-wrap .mobile-feedback-footer-wrap {
    display: none;
}

.results-page-wrap .results-pagination-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    margin-top: 20px;
    width: fit-content;
    color: white;
    gap: 100px;
}

.results-page-wrap .mobile-results-pagination-wrap {
    display: none;
}

.results-page-wrap .mobile-buttons-wrap {
    display: none;
}

@media screen and (max-width: 1650px) {
    .results-page-wrap .improvment-title {
        margin: 10px 0px;
    }

    .results-page-wrap .buttons-wrap {
        margin: 10px 0px;
    }

    .results-page-wrap .primaryButton {
        padding: 8px 15px;
    }

    .results-page-wrap .secondaryButton {
        padding: 8px 15px;
    }

    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-desc .lineheightPara {
        line-height: 20px;
    }

    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-wrap {
        margin-top: 8px;
    }

    .results-page-wrap .video-container {
        width: 25%;
        height: 350px;
    }
}

@media screen and (max-width: 768px) {
    .results-page-wrap .feedback-footer-wrap {
        flex-wrap: wrap-reverse;
    }

    .results-page-wrap .buttons-wrap {
        flex-wrap: wrap;
    }

    .results-page-wrap .video-container {
        width: 100%;
        max-width: unset;
    }

    .results-page-wrap .feedbacks-content-wrap {
        width: 100%;
    }

    .results-page-wrap .primaryButton {
        width: 100%;
        min-width: unset;
    }

    .results-page-wrap .secondaryButton {
        width: 100%;
    }

    .results-page-wrap .results-content-header {
        flex-wrap: wrap;
    }

    .results-page-wrap .feedbacks-content-wrap .feedback-content-wrap {
        max-height: unset;
    }
}

@media screen and (max-width: 480px) {
    .results-page-wrap .results-content-wrap {
        padding: 10px 20px;
    }

    .results-page-wrap .results-content-header {
        display: none;
    }

    .results-page-wrap .result-mobile-header {
        display: flex;
        flex-direction: column;
    }

    .results-page-wrap .roundButton {
        width: auto;
        border-radius: 100px;
        padding: 8px !important;
    }

    .results-page-wrap .back {
        font-size: 14px;
    }

    .results-page-wrap .improvment-title {
        background: #ffb800;
        color: black;
        gap: 9px;
        font-size: 12px;
        border-radius: 10px;
        padding: 10px 14px;
        margin-top: 15px;
        margin-bottom: 17px;
    }

    .results-page-wrap .based-on-title {
        font-size: 12px;
    }

    .results-page-wrap .buttons-wrap {
        display: none;
    }

    .results-page-wrap .feedback-footer-wrap {
        display: none;
    }

    .results-page-wrap .mobile-feedback-footer-wrap {
        display: flex;
        margin-top: 12px;
    }

    .results-page-wrap .feedbacks-content-wrap {
        padding: 16px 12px;
    }

    .results-page-wrap .feedbacks-content-wrap .feedback-heading {
        font-size: 12px;
    }

    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ques-title {
        font-size: 12px;
    }

    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ques-desc {
        font-size: 12px;
        margin-bottom: 5px;
    }

    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-title {
        font-size: 12px;
        margin-bottom: 3px;
    }

    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-desc {
        font-size: 12px;
    }

    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-desc .lineheightPara {
        line-height: 18px;
    }

    .results-page-wrap .feedback-content-wrap .feedback-card-wrap .feedback-icons {
        width: 18px;
    }

    .results-page-wrap .feedbacks-content-wrap .feedback-content-wrap {
        gap: 15px;
    }

    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ques-wrap {
        min-height: 26px;
    }

    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-wrap {
        margin-top: 5px;
    }

    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-desc p:nth-of-type(1) {
        margin-bottom: 1px;
        line-height: 18px;
    }

    .results-page-wrap .mobile-video-wrap {
        display: flex;
        background: #382e4b;
        border-radius: 10px;
        overflow: hidden;
        padding: 8px;
        gap: 11px;
        margin-left: 31px;
        margin-top: 20px;
    }

    .results-page-wrap .mobile-video-wrap .video-heading {
        font-size: 12px;
        font-weight: 700;
        line-height: 32px;
        letter-spacing: -0.02em;
        text-align: left;
    }

    .results-page-wrap .mobile-video-wrap .video-desc {
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: -0.02em;
        text-align: left;
    }

    .results-page-wrap .mobile-video-wrap .video-desc span {
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: -0.02em;
        text-align: left;
        text-decoration: underline;
        white-space: nowrap;
    }

    .results-page-wrap .play-button-overlay img {
        width: 16px;
    }

    .results-page-wrap .video-container {
        width: 80px;
        border-radius: 10px;
        overflow: hidden;
        height: unset;
    }

    .results-page-wrap .results-pagination-wrap {
        display: none;
    }

    .results-page-wrap .mobile-results-pagination-wrap {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: -0.02em;
        text-align: center;
        margin-top: 25px;
    }

    .results-page-wrap .mobile-results-pagination-wrap img {
        width: 16px;
    }

    .results-page-wrap .primaryButton {
        font-size: 12px;
        padding: 17px 5px;
        height: fit-content;
    }

    .results-page-wrap .greenColor {
        background-color: #06efc5;
    }

    .results-page-wrap .primaryButton img {
        width: 16px;
    }

    .results-page-wrap .secondaryButton {
        font-size: 12px;
        padding: 17px 5px;
        height: fit-content;
    }

    .results-page-wrap .secondaryButton img {
        width: 16px;
    }

    .results-page-wrap .mobile-buttons-wrap {
        display: flex;
        gap: 12px;
        margin-top: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/InterviewSimulatorPages/InterviewSimulator/results.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,YAAY;IACZ,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,oBAAoB;QACpB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,YAAY;QACZ,QAAQ;QACR,eAAe;QACf,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,SAAS;QACT,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,uBAAuB;QACvB,gBAAgB;QAChB,0BAA0B;QAC1B,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,eAAe;QACf,gBAAgB;QAChB,uBAAuB;QACvB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,SAAS;QACT,gBAAgB;IACpB;AACJ","sourcesContent":[".results-page-wrap {\n    min-height: 100vh;\n    font-family: \"Inter\", sans-serif;\n}\n\n.results-page-wrap .results-content-wrap {\n    padding: 20px 50px;\n    background: #150924;\n    min-height: calc(100vh - 83px);\n    display: flex;\n    flex-direction: column;\n    /* justify-content: space-between; */\n}\n\n.results-page-wrap .result-mobile-header {\n    display: none;\n}\n\n.results-page-wrap .results-content-header {\n    display: flex;\n    justify-content: space-between;\n}\n\n.results-page-wrap .back {\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    letter-spacing: -0.02em;\n    text-align: left;\n    color: #ffffff;\n    display: flex;\n    gap: 12px;\n}\n\n.results-page-wrap .improvment-title {\n    font-family: \"Inter\", sans-serif;\n    font-size: 24px;\n    font-weight: 600;\n    letter-spacing: -0.02em;\n    text-align: left;\n    color: #ffb800;\n    display: flex;\n    gap: 16px;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.results-page-wrap .greenColor {\n    color: #06efc5;\n}\n\n.results-page-wrap .based-on-title {\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    letter-spacing: -0.02em;\n    text-align: left;\n    color: #ffffff;\n}\n\n.results-page-wrap .buttons-wrap {\n    display: flex;\n    margin: 30px 0px;\n    gap: 30px;\n}\n\n.results-page-wrap .video-container {\n    position: relative;\n    width: 43%;\n    max-width: 480px;\n    /* height: auto; */\n    cursor: pointer;\n    height: 450px;\n}\n\n.results-page-wrap video {\n    width: 100%;\n    height: 100%;\n}\n\n.play-button-overlay {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 48px;\n    color: white;\n    text-shadow: 0px 0px 5px black;\n    pointer-events: none;\n}\n\n.results-page-wrap .primaryButton {\n    background: #06efc5;\n    font-size: 18px;\n    font-weight: 800;\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    justify-content: center;\n    text-wrap: nowrap;\n    line-height: normal;\n    padding: 13px 17px;\n    min-width: 357px;\n    height: fit-content;\n    -webkit-text-fill-color: #242424;\n}\n\n.results-page-wrap .secondaryButton {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    justify-content: center;\n    background: #ffffff1a;\n    color: #ffffff;\n    font-size: 18px;\n    font-weight: 600;\n    text-align: center;\n    font-family: \"Inter\", sans-serif;\n    text-wrap: nowrap;\n    height: fit-content;\n    padding: 13px 25px;\n    line-height: normal;\n    -webkit-text-fill-color: #ffffff;\n}\n\n.results-page-wrap .downloadButton {\n    font-size: 16px;\n    padding: 15px 16px;\n}\n\n.results-page-wrap .feedbacks-content-wrap {\n    background: #291e36;\n    color: white;\n    padding: 20px;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    width: 68vw;\n}\n\n.results-page-wrap .feedbacks-content-wrap .feedback-heading {\n    font-size: 16px;\n    font-weight: 600;\n    letter-spacing: -0.02em;\n    text-align: left;\n    margin-bottom: 20px;\n}\n\n.results-page-wrap .feedbacks-content-wrap .feedback-content-wrap {\n    max-height: 44vh;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n    padding-right: 20px;\n}\n\n.results-page-wrap .feedbacks-content-wrap .feedback-card-wrap {\n    display: flex;\n    gap: 16px;\n}\n\n.results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ques-title {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: normal;\n    letter-spacing: -0.02em;\n    text-align: left;\n}\n\n.results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ques-desc {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: normal;\n    letter-spacing: -0.02em;\n    text-align: left;\n}\n\n.results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-title {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: normal;\n    letter-spacing: -0.02em;\n    text-align: left;\n    margin-bottom: 12px;\n}\n\n.results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-desc {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: normal;\n    letter-spacing: -0.02em;\n    text-align: left;\n}\n\n.results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-wrap {\n    margin-top: 20px;\n    padding-left: 10px;\n}\n\n.results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ques-wrap {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    min-height: 42px;\n    justify-content: center;\n}\n\n.results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-desc p:nth-of-type(1) {\n    margin-bottom: 8px;\n}\n\n.results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-desc .lineheightPara {\n    line-height: 32px;\n    margin-bottom: 0;\n}\n\n.results-page-wrap .feedback-footer-wrap {\n    display: flex;\n    gap: 23px;\n    justify-content: space-between;\n}\n\n.results-page-wrap .mobile-feedback-footer-wrap {\n    display: none;\n}\n\n.results-page-wrap .results-pagination-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 0 auto;\n    margin-top: 20px;\n    width: fit-content;\n    color: white;\n    gap: 100px;\n}\n\n.results-page-wrap .mobile-results-pagination-wrap {\n    display: none;\n}\n\n.results-page-wrap .mobile-buttons-wrap {\n    display: none;\n}\n\n@media screen and (max-width: 1650px) {\n    .results-page-wrap .improvment-title {\n        margin: 10px 0px;\n    }\n\n    .results-page-wrap .buttons-wrap {\n        margin: 10px 0px;\n    }\n\n    .results-page-wrap .primaryButton {\n        padding: 8px 15px;\n    }\n\n    .results-page-wrap .secondaryButton {\n        padding: 8px 15px;\n    }\n\n    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-desc .lineheightPara {\n        line-height: 20px;\n    }\n\n    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-wrap {\n        margin-top: 8px;\n    }\n\n    .results-page-wrap .video-container {\n        width: 25%;\n        height: 350px;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .results-page-wrap .feedback-footer-wrap {\n        flex-wrap: wrap-reverse;\n    }\n\n    .results-page-wrap .buttons-wrap {\n        flex-wrap: wrap;\n    }\n\n    .results-page-wrap .video-container {\n        width: 100%;\n        max-width: unset;\n    }\n\n    .results-page-wrap .feedbacks-content-wrap {\n        width: 100%;\n    }\n\n    .results-page-wrap .primaryButton {\n        width: 100%;\n        min-width: unset;\n    }\n\n    .results-page-wrap .secondaryButton {\n        width: 100%;\n    }\n\n    .results-page-wrap .results-content-header {\n        flex-wrap: wrap;\n    }\n\n    .results-page-wrap .feedbacks-content-wrap .feedback-content-wrap {\n        max-height: unset;\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .results-page-wrap .results-content-wrap {\n        padding: 10px 20px;\n    }\n\n    .results-page-wrap .results-content-header {\n        display: none;\n    }\n\n    .results-page-wrap .result-mobile-header {\n        display: flex;\n        flex-direction: column;\n    }\n\n    .results-page-wrap .roundButton {\n        width: auto;\n        border-radius: 100px;\n        padding: 8px !important;\n    }\n\n    .results-page-wrap .back {\n        font-size: 14px;\n    }\n\n    .results-page-wrap .improvment-title {\n        background: #ffb800;\n        color: black;\n        gap: 9px;\n        font-size: 12px;\n        border-radius: 10px;\n        padding: 10px 14px;\n        margin-top: 15px;\n        margin-bottom: 17px;\n    }\n\n    .results-page-wrap .based-on-title {\n        font-size: 12px;\n    }\n\n    .results-page-wrap .buttons-wrap {\n        display: none;\n    }\n\n    .results-page-wrap .feedback-footer-wrap {\n        display: none;\n    }\n\n    .results-page-wrap .mobile-feedback-footer-wrap {\n        display: flex;\n        margin-top: 12px;\n    }\n\n    .results-page-wrap .feedbacks-content-wrap {\n        padding: 16px 12px;\n    }\n\n    .results-page-wrap .feedbacks-content-wrap .feedback-heading {\n        font-size: 12px;\n    }\n\n    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ques-title {\n        font-size: 12px;\n    }\n\n    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ques-desc {\n        font-size: 12px;\n        margin-bottom: 5px;\n    }\n\n    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-title {\n        font-size: 12px;\n        margin-bottom: 3px;\n    }\n\n    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-desc {\n        font-size: 12px;\n    }\n\n    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-desc .lineheightPara {\n        line-height: 18px;\n    }\n\n    .results-page-wrap .feedback-content-wrap .feedback-card-wrap .feedback-icons {\n        width: 18px;\n    }\n\n    .results-page-wrap .feedbacks-content-wrap .feedback-content-wrap {\n        gap: 15px;\n    }\n\n    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ques-wrap {\n        min-height: 26px;\n    }\n\n    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-wrap {\n        margin-top: 5px;\n    }\n\n    .results-page-wrap .feedbacks-content-wrap .feedback-card-wrap .ans-desc p:nth-of-type(1) {\n        margin-bottom: 1px;\n        line-height: 18px;\n    }\n\n    .results-page-wrap .mobile-video-wrap {\n        display: flex;\n        background: #382e4b;\n        border-radius: 10px;\n        overflow: hidden;\n        padding: 8px;\n        gap: 11px;\n        margin-left: 31px;\n        margin-top: 20px;\n    }\n\n    .results-page-wrap .mobile-video-wrap .video-heading {\n        font-size: 12px;\n        font-weight: 700;\n        line-height: 32px;\n        letter-spacing: -0.02em;\n        text-align: left;\n    }\n\n    .results-page-wrap .mobile-video-wrap .video-desc {\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 18px;\n        letter-spacing: -0.02em;\n        text-align: left;\n    }\n\n    .results-page-wrap .mobile-video-wrap .video-desc span {\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 18px;\n        letter-spacing: -0.02em;\n        text-align: left;\n        text-decoration: underline;\n        white-space: nowrap;\n    }\n\n    .results-page-wrap .play-button-overlay img {\n        width: 16px;\n    }\n\n    .results-page-wrap .video-container {\n        width: 80px;\n        border-radius: 10px;\n        overflow: hidden;\n        height: unset;\n    }\n\n    .results-page-wrap .results-pagination-wrap {\n        display: none;\n    }\n\n    .results-page-wrap .mobile-results-pagination-wrap {\n        display: flex;\n        justify-content: space-between;\n        font-size: 12px;\n        font-weight: 600;\n        letter-spacing: -0.02em;\n        text-align: center;\n        margin-top: 25px;\n    }\n\n    .results-page-wrap .mobile-results-pagination-wrap img {\n        width: 16px;\n    }\n\n    .results-page-wrap .primaryButton {\n        font-size: 12px;\n        padding: 17px 5px;\n        height: fit-content;\n    }\n\n    .results-page-wrap .greenColor {\n        background-color: #06efc5;\n    }\n\n    .results-page-wrap .primaryButton img {\n        width: 16px;\n    }\n\n    .results-page-wrap .secondaryButton {\n        font-size: 12px;\n        padding: 17px 5px;\n        height: fit-content;\n    }\n\n    .results-page-wrap .secondaryButton img {\n        width: 16px;\n    }\n\n    .results-page-wrap .mobile-buttons-wrap {\n        display: flex;\n        gap: 12px;\n        margin-top: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
